import { TCustomAxiosError } from '@/services/api';
import { deleteOrganizationLead } from '@/services/api/requests/organizationLeads';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import useToast from '../useToast';

export const useDeleteOrganizationLead = (
  onSuccess?: () => void,
): {
  isError: boolean;
  isPending: boolean;
  mutate: UseMutateFunction<any, TCustomAxiosError, string, unknown>;
} => {
  const toast = useToast();

  const { mutate, isPending, isError } = useMutation({
    mutationFn: async (orgSlug: string) => {
      const response = await deleteOrganizationLead(orgSlug);
      return response;
    },
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Success',
        description: 'Organization lead successfully deleted.',
      });

      onSuccess?.();
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        status: 'error',
        title: 'Organization lead deletion error',
        description: error.errors[0]?.message,
      });
    },
  });

  return { mutate, isPending, isError };
};
